import { Checkbox, Collapse, TableCell, TableRow } from "@material-ui/core";
import React, { Fragment, useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { ComponentUtil, Formater } from "src/framework/commons";
import { ColumnDefinition } from "src/framework/store";

interface ExpandableRowProperties {
  row: any;
  columnDefinitions: ColumnDefinition[];
  renderExpandable?: (row: any) => React.ReactNode | null;
  checkable?: boolean;
  isChecked: boolean;
  onCheck?: <T = any>(row: T) => void;
}

const ExpandableRow: React.FC<ExpandableRowProperties> = ({
  row,
  columnDefinitions,
  renderExpandable,
  checkable = false,
  isChecked = false,
  onCheck,

}) => {
  // const { row, columnDefinitions, renderExpandable } = props;
  const [open, setOpen] = useState<boolean>(false);

  return (
    <Fragment>
      <TableRow key={ComponentUtil.keyGen(row["id"])}>

        {checkable ? (
          <TableCell padding="checkbox">
            <Checkbox
              checked={isChecked}
              onChange={() => {
                if (onCheck) {
                  onCheck(row);
                }
              }}
            />
          </TableCell>
        ) : ""}

        {columnDefinitions.map((columnDef: ColumnDefinition, idx: number) => {
          const key = `cell-${columnDef.field}-${idx}`;
          if (columnDef.field === "expandable") {
            return (
              <TableCell width={columnDef.width} key={key}>
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => setOpen(!open)}
                >
                  {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
              </TableCell>
            );
          }

          if (columnDef.render) {
            return (
              <TableCell key={key} width={columnDef.width} align={Formater.toAlign(columnDef?.type, columnDef?.align)}>
                {columnDef.render(row)}
              </TableCell>
            );
          }

          return (
            <TableCell key={key} width={columnDef.width} align={Formater.toAlign(columnDef?.type, columnDef?.align)}>
              {columnDef.type
                ? Formater.toString(row[columnDef.field], columnDef?.type)
                : row[columnDef.field]}
            </TableCell>
          );
        })}
      </TableRow>
      <TableRow>
        <td
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={columnDefinitions.length}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            {renderExpandable ? renderExpandable(row) : ""}
          </Collapse>
        </td>
      </TableRow>
    </Fragment>
  );
};

export { ExpandableRow };
